import React, { Component } from 'react';
import '../styles/App.css';
import AppRouter from './AppRouter';
import { Container, Notification, Section, Button } from 'react-bulma-components';
import lightson from '../assets/merged-eds.png';

class Main extends Component {
  render() {
    return (
        <Section className="main-wrapper">
          <Section className="container-fluid top-section" data-aos="fade-in">
            <Container>
              <Notification className="hero-container">
                <Section className="hero-image"></Section>
              </Notification>
              <Notification className="hero-content">
                <Section className="introduction">Hi, I'm Nirmal</Section>
                <Section className="introduction">&</Section>
                <Section className="introduction">I am an Engineer of Web</Section>
                <hr/>
                <Section className="description">I am a passionate software engineer with 10+ years of experience working with several top companies and building awesome web applications</Section>
              </Notification>
              <Notification className="space-content">
              </Notification>
            </Container>
          </Section>
          <Section className="container-fluid middle-section">
              <Section className="work-description flex">
                <Section className="img-box lightsoff">
                    <Section className="reveal-holder lightson-img" data-aos="fade-left" data-aos-duration="1500">
                      <img src={lightson}></img>
                    </Section>
                    <Section className="company-details" data-aos="fade-right" data-aos-duration="1500">
                      <Section className="pair">
                        <Section className="key">Company</Section>
                        <Section className="value">GE HEALTHCARE</Section>
                      </Section>
                      <Section className="pair">
                        <Section className="key">Year</Section>
                        <Section className="value">2018 - 2021</Section>
                      </Section>
                      <Section className="pair">
                        <Section className="key">Awards</Section>
                        <Section className="value">Red Dot Interface Design Award</Section>
                        <Section className="value">Fast Company's Innovation by Design Awards</Section>
                        <Section className="value">DMI: Design Value award winner</Section>
                      </Section>
                    </Section>
                </Section>
                <Section className="content-box" data-aos="fade-up-left" data-aos-duration="1500">
                  <Section className="eds-title">
                      <p>Edison Design System</p>
                    </Section>
                    <Section className="eds-about">
                      <Section className="eds-intro">
                        <p>The Edison™ Design System (EDS) makes it easy to create powerful, user-friendly web applications with components built to withstand the demand of industrial use cases. 
                        </p>
                      </Section>
                      <Section>
                        <p className="eds-problem">Problem Statement</p>
                        <p className="problem-statement">Feedback from customers that GE Healthcare products appear dated and operate as if they were created by different companies</p>
                      </Section>
                      <Section>
                        <p className="eds-problem">Solution</p>
                        <p className="problem-statement">A library of validated web and CSS only components for creating consistent, modern and intuitive healthcare web applications</p>
                      </Section>
                      <Section>
                        <p className="eds-problem">My Role</p>
                        <p className="problem-statement">As a Staff Software Engineer on the Edison Design System team, my responsibilities include understanding the requirements and designs 
                        from UX team and developing highly functional user-friendly web and CSS only components which enables faster development of healthcare software.</p>
                      </Section>
                    </Section>
                </Section>
              </Section>
            </Section>
          </Section>
    );
  }
}

export default Main;